import { Chapter, FadeUp } from "../Reveal";

const STEPS = [
  {
    num: "01",
    title: "Vous présentez votre besoin",
    desc: "Matériaux recherchés, chantier, quantités et délai.",
    testid: "etape-1",
  },
  {
    num: "02",
    title: "Nous qualifions la demande",
    desc: "Le commercial précise les caractéristiques utiles et les contraintes.",
    testid: "etape-2",
  },
  {
    num: "03",
    title: "Échange ou déplacement",
    desc: "Un rendez-vous peut être organisé sur chantier si nécessaire.",
    testid: "etape-3",
  },
  {
    num: "04",
    title: "Recherche de la solution",
    desc: "Sélection des familles, références et configurations pertinentes.",
    testid: "etape-4",
  },
  {
    num: "05",
    title: "Proposition commerciale",
    desc: "Une réponse structurée est préparée après qualification du besoin.",
    testid: "etape-5",
  },
];

export const Methode = () => (
  <section
    id="methode"
    data-testid="methode-section"
    className="bg-petrol text-ivoire py-20 lg:py-32 relative overflow-hidden grain scroll-mt-16"
  >
    <div
      className="absolute -bottom-32 -left-32 w-[380px] h-[380px] rounded-t-full bg-teal/15 rotate-45"
      aria-hidden="true"
    />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
      <Chapter num="06" label="La méthode EQUORIS" dark />
      <FadeUp>
        <h2 className="font-display font-medium text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight mb-16 lg:mb-24">
          Du besoin à la proposition.
        </h2>
      </FadeUp>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-x-8 gap-y-12">
        {STEPS.map(({ num, title, desc, testid }, i) => (
          <FadeUp key={testid} delay={i * 0.12}>
            <div data-testid={testid} className="group relative">
              <p className="font-display italic font-light text-6xl lg:text-7xl text-sage/60 transition-colors duration-500 group-hover:text-sage leading-none mb-5">
                {num}
              </p>
              <div className="h-px w-full bg-ivoire/15 mb-5 relative">
                <span className="absolute left-0 top-0 h-px w-0 bg-sage transition-all duration-700 group-hover:w-full" />
              </div>
              <h3 className="text-base font-semibold mb-2.5">{title}</h3>
              <p className="text-[13px] text-ivoire/60 leading-relaxed">{desc}</p>
            </div>
          </FadeUp>
        ))}
      </div>

      <FadeUp delay={0.2} className="mt-20 lg:mt-28">
        <p
          data-testid="methode-phrase-finale"
          className="font-display italic text-center text-2xl sm:text-3xl text-ivoire/90"
        >
          « Une seule demande pour cadrer votre besoin. »
        </p>
      </FadeUp>
    </div>
  </section>
);
